import axios from "axios";
import { getRequestOptions } from "../../resources/configs/requests";
import { GET_KIOSK_QUESTIONNAIRE_URL } from "../../resources/configs/URL";
import { formatGetKioskQuestionnaireErrorMessage } from "../../resources/messages/ErrorMessage";
import {
  GetKioskQuestionnaireRequestPayload,
  GetKioskQuestionnaireResponsePayload,
} from "./getKioskQuestionnaire.Api.types";
import { parseResponse } from "../../resources/handlers/parseResponse/parseResponse";

/**
 * Retrieves the kiosk questionnaire displayed during the appointment registration flow,
 * just before clicking to register for an appointment.
 *
 * POST
 * Endpoint: /appointment/GetKioskQuestionnaire
 *
 * @param {string | null} memberIdentifier  Member Identifier of the person we are making this request for
 * @param {string | null} regInstitutionCode  Reg Code of the institution of the service tied to this appointment
 * @param {string | null} targetSystem  Source system of this institution
 * @param {string | null} visitType visitType of this appointment
 *
 * @returns {GetKioskQuestionnaireResponsePayload} Response payload from the remote API
 */
const getKioskQuestionnaire = async (
  params: GetKioskQuestionnaireRequestPayload,
): Promise<GetKioskQuestionnaireResponsePayload> => {
  try {
    const response = await axios.post<GetKioskQuestionnaireResponsePayload>(
      GET_KIOSK_QUESTIONNAIRE_URL(),
      params,
      getRequestOptions(),
    );
    return parseResponse(response, GET_KIOSK_QUESTIONNAIRE_URL());
  } catch (error) {
    const msg = formatGetKioskQuestionnaireErrorMessage(
      GET_KIOSK_QUESTIONNAIRE_URL(),
    );
    console.error(msg);
    throw error;
  }
};

export { getKioskQuestionnaire };
